/* eslint-disable unicorn/filename-case -- TODO rename later */
import { checkIsLinkedModel } from "~/utils/file";

export const modelTypes = {
  "3mf": {
    previewable: true,
    type: "3dviewer",
  },
  aedt: {
    previewable: false,
    type: "file",
  },
  aedtz: {
    previewable: false,
    type: "file",
  },
  asm: {
    previewable: false,
    type: "file",
  },
  bdf: {
    previewable: false,
    type: "file",
  },
  bmp: {
    previewable: true,
    type: "image",
  },
  catpart: {
    previewable: false,
    type: "file",
  },
  catproduct: {
    previewable: false,
    type: "file",
  },
  csv: {
    previewable: true,
    type: "text",
  },
  dat: {
    previewable: false,
    type: "file",
  },
  docx: {
    previewable: true,
    type: "docx",
  },
  fig: {
    previewable: false,
    type: "file",
  },
  gif: {
    previewable: true,
    type: "image",
  },
  glb: {
    previewable: true,
    type: "3dviewer",
  },
  gltf: {
    previewable: true,
    type: "3dviewer",
  },
  htm: {
    previewable: true,
    type: "text",
  },
  html: {
    previewable: true,
    type: "text",
  },
  jpg: {
    previewable: true,
    type: "image",
  },
  jpeg: {
    previewable: true,
    type: "image",
  },
  json: {
    previewable: true,
    type: "text",
  },
  m: {
    previewable: false,
    type: "file",
  },
  md: {
    previewable: true,
    type: "markdown",
  },
  markdown: {
    previewable: true,
    type: "markdown",
  },
  mat: {
    previewable: false,
    type: "file",
  },
  mdxml: {
    previewable: false,
    type: "file",
  },
  mdzip: {
    previewable: false,
    type: "file",
  },
  msh: {
    previewable: true,
    type: "3dviewer",
  },
  obj: {
    previewable: true,
    type: "3dviewer",
  },
  op2: {
    previewable: false,
    type: "file",
  },
  pdf: {
    previewable: true,
    type: "pdf",
  },
  png: {
    previewable: true,
    type: "image",
  },
  ppt: {
    previewable: false,
    type: "file",
  },
  pptx: {
    previewable: false,
    type: "file",
  },
  prt: {
    previewable: false,
    type: "file",
  },
  py: {
    previewable: true,
    type: "text",
  },
  slx: {
    previewable: false,
    type: "file",
  },
  step: {
    previewable: false,
    type: "file",
  },
  stl: {
    previewable: true,
    type: "3dviewer",
  },
  stp: {
    previewable: false,
    type: "file",
  },
  svg: {
    previewable: true,
    type: "image",
  },
  sysml: {
    previewable: true,
    type: "text",
  },
  txt: {
    previewable: true,
    type: "text",
  },
  xlst: {
    previewable: false,
    type: "file",
  },
  xlsx: {
    previewable: false,
    type: "file",
  },
  xml: {
    previewable: true,
    type: "text",
  },
  zip: {
    previewable: false,
    type: "file",
  },
};

export function isModelTypeKey(key: string): key is keyof typeof modelTypes {
  return Object.prototype.hasOwnProperty.call(modelTypes, key);
}

// CAD-like formats: non-previewable; mapped to Box icon. Viewable mesh formats use FileBox.
export const cadLike3dExtensions = new Set<keyof typeof modelTypes>([
  "step",
  "stp",
  "prt",
  "asm",
  "catpart",
  "catproduct",
]);

export const is3DLikeExtension = (extension?: string): boolean => {
  if (!extension) return false;
  return cadLike3dExtensions.has(extension.toLowerCase() as keyof typeof modelTypes);
};

export const isModelPreviewable = (extension?: string) => {
  if (!extension) {
    return false;
  }
  const normalized = extension.toLowerCase();
  const isLink = checkIsLinkedModel(normalized);
  return modelTypes[normalized as keyof typeof modelTypes]?.previewable || isLink;
};
